export const isPreviewEnvironment = import.meta.env.VITE_PREVIEW_MODE === "true";

export const previewEnvironmentLabel =
  import.meta.env.VITE_PREVIEW_LABEL || "Синов муҳити — production эмас";
